'use client'

import { useQuery } from '@tanstack/react-query'
import { useTranslations } from 'next-intl'

import { roomQueries } from '@/entities/room'

import { Chip } from './chip'

type Props = {
  onClick: (keyword: string) => void
}

export const MobileKeywordList = ({ onClick }: Props) => {
  const t = useTranslations('search_panel')

  const { data } = useQuery({
    ...roomQueries.recommendSearchKeywords(),
    staleTime: Infinity,
    enabled: false,
  })

  const keywords = data?.keywords ?? []

  if (keywords.length === 0) return null

  const handleKeywordClick = (keyword: string) => () => {
    onClick(keyword)
  }

  return (
    <section className="space-y-4 pb-4">
      <h2 className="typo-headline3 font-semibold text-black">
        {t('recommended_keyword.title')}
      </h2>
      <ul className="flex flex-wrap gap-2">
        {keywords.map(keyword => (
          <li key={keyword}>
            <Chip
              className="w-fit min-w-16"
              onClick={handleKeywordClick(keyword)}
            >
              {keyword}
            </Chip>
          </li>
        ))}
      </ul>
    </section>
  )
}
